module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "backbar_wrapper"
  }, [_c('div', {
    staticClass: "backbar"
  }, [_c('router-link', {
    attrs: {
      "to": '/preventiontips/tips'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/icon-chevron.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])])], 1)])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          預防螞蟻小貼士\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          防止螞蟻的入侵\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('h1', [_vm._v("預防螞蟻小貼士")]), _vm._v(" "), _c('p', [_vm._v("螞蟻是團結性很強的昆蟲，它們喜歡成群結隊的生活。如果看到有一隻螞蟻出現，代表家裡已經響起螞蟻的警號，要成功阻止螞蟻進入家中，就要從內外兩方面著手。")]), _vm._v(" "), _c('h1', [_vm._v("屋外")]), _vm._v(" "), _c('p', [_vm._v("螞蟻入侵房屋可以是非常麻煩的一件事。如果不採取任何預防措施，螞蟻會迅速佔據您的家。要防止它們內進，請參考以下幾個貼士：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("若房屋內有盆栽或比較接近山坡草叢，請關緊門窗之間的縫隙和裂縫，以防止螞蟻從樹枝或樹葉爬到家中。")]), _vm._v(" "), _c('li', [_vm._v("枯萎和乾燥的植物往往是螞蟻所聚集的地方。請立即清除後院和其他戶外區域枯萎了的植物。")])]), _vm._v(" "), _c('h1', [_vm._v("屋內")]), _vm._v(" "), _c('p', [_vm._v("螞蟻需要食物、水、溫暖和安全，所以屋內家居對它們來說是完美的棲息地，但是，螞蟻聚集成穴會帶來很多麻煩。請參考以下幾個簡單貼士從家居著手，防止螞蟻入侵：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("食物是螞蟻的目標。請將所有食物保存在玻璃、塑料等密封的容器，以防止螞蟻的入侵。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻經常在雪櫃底部找到它們喜歡的食物碎屑，請定期清潔雪櫃底部， 特別要掃走食物碎屑並把污跡擦乾淨。")]), _vm._v(" "), _c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66cd6a5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PTipsTipsAnt.vue
// module id = 242
// module chunks = 0